import { request } from './auth-actions'
import paymentEngineApi from '../../api/payment-engine-api'
import { notify } from './notification-actions'
import { NOTIFY_DANGER, NOTIFY_SUCCESS } from './action-types'
import { getText } from '../../internal/TextLabels'
import { genericError, silentError } from './action-utils'
import { getTransactionDetails } from './transactions-actions'

export const updateAutomaticDebitDate = (id, debitDate) => dispatch =>
  dispatch(
    request(paymentEngineApi.payment.updateAutomaticDebitDate(id, debitDate)),
  )
    .then(() =>
      notify(
        NOTIFY_SUCCESS,
        getText('ongoingPayments.updateAutomaticDebitDate.success'),
      ),
    )
    .then(() => dispatch(getTransactionDetails(id)))
    .catch(error => {
      silentError(error)
      notify(
        NOTIFY_DANGER,
        getText('ongoingPayments.updateAutomaticDebitDate.error'),
      )
    })

export const cancelPayment = paymentId => dispatch =>
  dispatch(request(paymentEngineApi.payment.cancel(paymentId)))
    .then(() => dispatch(getTransactionDetails(paymentId)))
    .catch(error => {
      genericError(error)
      throw error
    })
